import { Continent } from '../../constants/countries';
import { EUNutritionTableRow, NutritionTableRow, USNutritionTableRow } from './NutritionTableRow';

export const isUSNutritionTableRow = (tableRow: NutritionTableRow): tableRow is USNutritionTableRow => tableRow.type === Continent.northAmerica;
export const isEUNutritionTableRow = (tableRow: NutritionTableRow): tableRow is EUNutritionTableRow => tableRow.type === Continent.europe;
